export const statusColor = (status) => {
  switch(status) {
    case "new":
      return "#FD9A8D"
      break;
    case "assigned":
      return "#FFAF7E"
      break;
    case "acknowledged":
      return "#FFAF7E"
      break;
    case "in_transit":
      return "#FFCF74"
      break;
    case "in_progress":
      return "#6BC2D1"
      break;
    case "closed":
      return  "#ABD19E"
      break;
    default:
      return "#BB84E9"
  } 
}